import { Serializable } from '@/models/serializable';
import { Tag } from '@/models/tag';
import { UtilitiesFunctions } from '@/helpers';
import {toDate} from "date-fns";

export class ExperienceAvailability implements Serializable<ExperienceAvailability> {
  id: string;
  active: boolean;
  adultsCount: number;
  maxAdults: number;
  minAdults: number;
  languages: Tag[];
  time: string;
  weekDay: string;
  day: string;
  deserialize(input: any): ExperienceAvailability {
    if (!input) return;
    this.id = input.id;
    this.active = input.active;
    this.adultsCount = input.occupied_count;
    this.maxAdults = input.max_parties;
    this.minAdults = input.min_parties;
    this.languages = input.enabled_languages ? input.enabled_languages.map(tag => new Tag().deserializeV2(tag)) : [];
    this.time = input.time;
    this.day = input.day;
    this.weekDay = new Date(this.day).getDay().toString();
    return this;
  }

  get calculcatedMaxAdults(): number {
    return this.maxAdults || 0;
  }

  get calculcatedMinAdults(): number {
    // In a near future maybe we need to rewrite this logic to include this.overrideMinAdults
    // return this.overrideMinAdults !== null && this.overrideMinAdults > 1 ? this.overrideMinAdults! : this.minAdults;
    return this.minAdults > this.adultsCount ? this.minAdults : 0 || 0;
  }
}

export default class ExperienceAvailabilityForDay implements Serializable<ExperienceAvailabilityForDay> {
  day: string;
  availabilities: ExperienceAvailability[];

  deserialize(input: any): ExperienceAvailabilityForDay {
    if (!input) return;
    this.day = input.day;
    this.availabilities = input.availabilities.map(av => new ExperienceAvailability().deserialize(av));
    return this;
  }
}
